import React, { useState } from "react";
import BaseCard from "../../lib/BaseCard";
import styled from "styled-components";
import Spinner from "../../lib/Spinner";



const OrderHistory = () => {
    const [state] = useState([
        { "id": 1, "title": "Fjallraven - Foldsack No. 1 Backpack, Fits 15 Laptops", "price": 109.95, "description": "Your perfect pack for everyday use and walks in the forest. Stash your laptop (up to 15 inches) in the padded sleeve, your everyday", "category": "men's clothing", "image": "https://fakestoreapi.com/img/81fPKd-2AYL._AC_SL1500_.jpg" },
        { "id": 2, "title": "Mens Casual Premium Slim Fit T-Shirts ", "price": 22.3, "description": "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.", "category": "men's clothing", "image": "https://fakestoreapi.com/img/71-3HjGNDUL._AC_SY879._SX._UX._SY._UY_.jpg" },
        { "id": 3, "title": "Mens Cotton Jacket", "price": 55.99, "description": "great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.", "category": "men's clothing", "image": "https://fakestoreapi.com/img/71li-ujtlUL._AC_UX679_.jpg" },
        { "id": 4, "title": "Mens Casual Slim Fit", "price": 15.99, "description": "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.", "category": "men's clothing", "image": "https://fakestoreapi.com/img/71YXzeOuslL._AC_UY879_.jpg" }
    ]);


    return (
    <>
      <GridContainer>
        {state[0] ? (
          <>
            <FilterBar>FILTERS</FilterBar>
            <Grid>
              {state.map((product) => (
                <BaseCard title={product.title} image={product.image} key={product.id}></BaseCard>
              ))}
            </Grid>
          </>
        ) : (
          <Spinner />
        )}
      </GridContainer>
    </>
    );

}
const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const FilterBar = styled.div`
  background-color: #d3d3d396;
  width: 80vw;
  height: 5em;
  display: flex;
  margin: 0 0 20px 0;
`;

const Grid = styled.div`
  width: 80vw;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-gap: 2em;
`;

const Card = styled.div`
  display: block;
  background-color: #e7e7e7;
  width: 100%;
  height: 100%;
  justify-self: center;
`;

const Image = styled.img`
  object-fit: fill;
  min-height: 15px;
  min-width: 150px;
  max-width: 400px;
  max-height: 400px;
`;

export default OrderHistory;